import {
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import fullSchema from '../../schema';

// Not on the new PDF, but intentionally kept online: sets a priority-processing
// flash for terminally ill Veterans (OBI-confirmed).
export default {
  uiSchema: {
    ...titleUI('Terminal illness'),
    isTerminallyIll: yesNoUI('Are you terminally ill?'),
  },
  schema: {
    type: 'object',
    properties: {
      isTerminallyIll: fullSchema.properties.isTerminallyIll,
    },
  },
};
